import 'es6-promise/auto'
import Vue from 'vue'
import App from './index.vue'
import router from '../../router/index'
import store from '../../vuex/store'
import {isMobile, wisLoading, wisToast} from '../../utils/util'
import { Message, MessageBox } from 'element-ui'
import { AjaxPlugin, LoadingPlugin, ToastPlugin } from 'k12vux'
Vue.use(AjaxPlugin)
Vue.use(LoadingPlugin)
Vue.use(ToastPlugin)
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$message = Message
Vue.prototype.$wisLoading = wisLoading
Vue.prototype.$wisToast = wisToast

Vue.prototype.$ELEMENT = { size: 'small' }
Vue.config.productionTip = false

if (isMobile()) {
  window.location.href = './mobile.html'
} else {
  window.document.title = '智原云校'
  window.appCode = 'plantform'
  ;(async () => {
    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  })()
}
